// subCategoryProductsSchemas.js

export const subCategoryProductsSchemas = {
  "/product/epoxy-resin-epon-1001-x-75/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/epoxy-resin-epon-1001-x-75#product",
        name: "EPON™ Resin 1001-X-75",
        description:
          "EPON™ Resin 1001-X-75 is a 75% solids epoxy resin solution in xylene designed for industrial maintenance coatings. It offers strong chemical and corrosion resistance with low color and is suitable for room-temperature curing applications such as primers, clear finishes, masonry sealers, and gloss or semi-gloss enamels.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/PHvNwsvHSGRYOVHPsd3PwMyJLitLglhBIK0My4wE.webp",
        url: "https://hutaib.org/product/epoxy-resin-epon-1001-x-75",
        category: "Epoxy Resin",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Hexion_1001_X_75.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/epoxy-resin-epon-1001-x-75",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/epoxy-resin-epon-1001-x-75#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "https://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Epoxy Resin",
            item: {
              "@id": "https://hutaib.org/product-category/epoxy-resin",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "EPON™ Resin 1001-X-75",
            item: {
              "@id":
                "https://hutaib.org/product/epoxy-resin-epon-1001-x-75#product",
            },
          },
        ],
      },
    ],
  },

  "/product/high-performance-epoxy-epon-828/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/high-performance-epoxy-epon-828#product",
        name: "EPON™ Resin 828",
        description:
          "EPON™ Resin 828 is a high-performance liquid epoxy resin based on bisphenol A chemistry, engineered for excellent adhesion, mechanical strength, and chemical stability. It is widely used in industrial coatings, adhesives, composites, and electrical applications where durability, resistance, and long-term performance are required under demanding conditions.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/IgLGYGi07mDmXMFJEsgoqhD2W3IqCro8hyOKFTsn.webp",
        url: "https://hutaib.org/product/high-performance-epoxy-epon-828",
        category: "Epoxy Resin",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/epon-resin-828.dat",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/high-performance-epoxy-epon-828",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/high-performance-epoxy-epon-828#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Epoxy Resin",
            item: {
              "@id": "https://hutaib.org/product-category/epoxy-resin",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "EPON™ Resin 828",
            item: {
              "@id":
                "https://hutaib.org/product/high-performance-epoxy-epon-828#product",
            },
          },
        ],
      },
    ],
  },

  "/product/lignin-based-superplasticizer-sodium-lignosulphonate/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#product",
        name: "Sodium Gluconate",
        description:
          "Sodium Gluconate is a high-performance concrete admixture used as a retarder and plasticizer to improve workability and control setting time in cementitious systems. It enhances dispersion of cement particles, supports smoother placement, and helps maintain consistent performance in a variety of concrete applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/66wNwZECuHYmfOsHipsoDgaqSBewuLSkEgkaPn1q.webp",
        url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/SODIUM_GLUCONATE.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Admixture",
            item: {
              "@id": "https://hutaib.org/product-category/admixture",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Sodium Gluconate",
            item: {
              "@id":
                "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#product",
            },
          },
        ],
      },
    ],
  },

  "/product/concrete-retarder-plasticizer-sodium-gluconate/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#product",
        name: "Sodium Gluconate",
        description:
          "Sodium Gluconate is a high-performance concrete admixture used as a retarder and plasticizer to improve workability and control setting time in cementitious systems. It enhances dispersion of cement particles, supports smoother placement, and helps maintain consistent performance in a variety of concrete applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/66wNwZECuHYmfOsHipsoDgaqSBewuLSkEgkaPn1q.webp",
        url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/SODIUM_GLUCONATE.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Admixture",
            item: {
              "@id": "https://hutaib.org/product-category/admixture",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Sodium Gluconate",
            item: {
              "@id":
                "https://hutaib.org/product/concrete-retarder-plasticizer-sodium-gluconate#product",
            },
          },
        ],
      },
    ],
  },

  "/product/naphthalene-based-superplasticizer/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/naphthalene-based-superplasticizer#product",
        name: "Sodium Naphthalene Sulfonate Formaldehyde",
        description:
          "Sodium Naphthalene Sulfonate Formaldehyde is a high-range water-reducing superplasticizer based on naphthalene sulfonate chemistry. It is designed to improve concrete flowability and workability while significantly reducing water demand, resulting in enhanced strength development, durability, and overall performance in cement-based systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/wR1jG1NdCBVgbED78SxbUARhk0JzVwBSyAMuZByI.webp",
        url: "https://hutaib.org/product/naphthalene-based-superplasticizer",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Sodium_Naphthalene_Sulfonate_Formaldehyde.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/naphthalene-based-superplasticizer",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/naphthalene-based-superplasticizer#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Admixture",
            item: {
              "@id": "https://hutaib.org/product-category/admixture",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Sodium Naphthalene Sulfonate Formaldehyde",
            item: {
              "@id":
                "https://hutaib.org/product/naphthalene-based-superplasticizer#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-pce-1021/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-pce-1021#product",
        name: "HIS PCE 1021",
        description:
          "HIS PCE 1021 is a high-performance powdered polycarboxylate ether-based superplasticizer engineered through advanced molecular design to enhance dispersion efficiency in cementitious systems. It provides excellent workability, improved flowability, and high strength development in cement-based mortars requiring superior fluidity and durability.",
        url: "https://hutaib.org/product/his-pce-1021",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_PCE_1021_Data_Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-pce-1021",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-pce-1021#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Admixture",
            item: {
              "@id": "https://hutaib.org/product-category/admixture",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS PCE 1021",
            item: {
              "@id": "https://hutaib.org/product/his-pce-1021#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-rdp-313n/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-rdp-313n#product",
        name: "HIS RDP 313N",
        description:
          "HIS RDP 313N is a redispersible polymer powder based on vinyl acetate-ethylene and VeoVa copolymer technology. It is designed for dry mix mortar systems where it enhances adhesion, flexibility, and durability. Upon mixing with water and application, it forms a stable polymer film after drying, improving performance in tile adhesives, skim coats, and other cementitious formulations.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/umx3MJ7pubBojc0U7DTCOtmKywVlcyUYgKbwHE9n.webp",
        url: "https://hutaib.org/product/his-rdp-313n",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_RDP_313N_Data_Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-rdp-313n",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-rdp-313n#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "RDP Grades",
            item: {
              "@id": "https://hutaib.org/product-category/rdp-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS RDP 313N",
            item: {
              "@id": "https://hutaib.org/product/his-rdp-313n#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-rdp-558f/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-rdp-558f#product",
        name: "HIS RDP 558F",
        description:
          "HIS RDP 558F is a highly flexible redispersible polymer powder based on a terpolymer system of vinyl acetate, ethylene, and acrylic. It is designed for dry mix mortar applications where it enhances adhesion, flexibility, hydrophobicity, and mechanical strength. It is especially suitable for tile adhesives, skim coats, and other cementitious systems requiring improved durability and water resistance after curing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/bVXTpg1b7ALfwDDnluZ4HS8xDlmph8rsWrT64qQC.webp",
        url: "https://hutaib.org/product/his-rdp-558f",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_RDP_558F_Data_Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-rdp-558f",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-rdp-558f#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "RDP Grades",
            item: {
              "@id": "https://hutaib.org/product-category/rdp-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS RDP 558F",
            item: {
              "@id": "https://hutaib.org/product/his-rdp-558f#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-rdp-558h/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-rdp-558h#product",
        name: "HIS RDP 558H",
        description:
          "HIS RDP 558H is a hydrophobic redispersible polymer powder based on vinyl acetate-ethylene and VeoVa copolymer technology. It is engineered to enhance water resistance, adhesion, flexibility, and mechanical strength in dry mix mortar systems. It is particularly suitable for tile adhesives, skim coats, and other cement-based applications requiring improved durability and long-term performance after curing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/IO30nFB7yywxta6LZIHLVhFbTp77qO8ibHEw3a2z.webp",
        url: "https://hutaib.org/product/his-rdp-558h",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_RDP_558H_Data-Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-rdp-558h",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-rdp-558h#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "RDP Grades",
            item: {
              "@id": "https://hutaib.org/product-category/rdp-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS RDP 558H",
            item: {
              "@id": "https://hutaib.org/product/his-rdp-558h#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-rdp-se-200/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-rdp-se-200#product",
        name: "HIS RDP SE-200",
        description:
          "HIS RDP SE-200 is a multi-purpose redispersible polymer powder based on a flexible vinyl acetate-ethylene copolymer system. It is designed for dry mix mortar applications, including tile adhesives, wall troweling compounds, and self-leveling flooring systems. It enhances workability, adhesion, flexibility, and open time, while improving performance after water exposure in cementitious formulations.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/fQoVE0w91ijDQpeVdylpHl2YNigIeVKFK3ga3QJj.webp",
        url: "https://hutaib.org/product/his-rdp-se-200",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_RDP_SE_200_Data-Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-rdp-se-200",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-rdp-se-200#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "RDP Grades",
            item: {
              "@id": "https://hutaib.org/product-category/rdp-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS RDP SE-200",
            item: {
              "@id": "https://hutaib.org/product/his-rdp-se-200#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-rdp-sl-100/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-rdp-sl-100#product",
        name: "HIS RDP SL-100",
        description:
          "HIS RDP SL-100 is a dispersible polymer powder designed for dry mix mortar applications, especially self-leveling flooring compounds and cement-based screeds. Based on a vinyl acetate-ethylene copolymer system, it improves leveling behavior, surface finish, workability, and stability of fresh mortar. Once cured, it enhances adhesion, flexural strength, deformability, and abrasion resistance in flooring systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/e6pRlbv80NIb8moFNQJW30z0TV25ZKubMoLknhtf.webp",
        url: "https://hutaib.org/product/his-rdp-sl-100",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_RDP_SL_100_DATA_SHEET.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-rdp-sl-100",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-rdp-sl-100#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "RDP Grades",
            item: {
              "@id": "https://hutaib.org/product-category/rdp-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS RDP SL-100",
            item: {
              "@id": "https://hutaib.org/product/his-rdp-sl-100#product",
            },
          },
        ],
      },
    ],
  },

  "/product/bos-sbr-9950/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bos-sbr-9950#product",
        name: "BOS SBR-9950",
        description:
          "BOS SBR-9950 is a synthetic rubber (SBR) based polymer emulsion used as a water-resistant bonding agent for cementitious systems. It improves adhesion, flexibility, and durability when added to cement slurry, mortar, concrete, or grout. It disperses easily in water and enhances overall performance of construction mixes by increasing water resistance and bonding strength.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/lytmKcpig3bpbkjlTuURRx2bzA9oiIiCkKn1EeCE.webp",
        url: "https://hutaib.org/product/bos-sbr-9950",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BOS_SBR_9950_PDF.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bos-sbr-9950",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bos-sbr-9950#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "SBR Grades",
            item: {
              "@id": "https://hutaib.org/product-category/sbr-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BOS SBR-9950",
            item: {
              "@id": "https://hutaib.org/product/bos-sbr-9950#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-sbr-7303/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-sbr-7303#product",
        name: "HIS SBR 7303",
        description:
          "HIS SBR 7303 is a styrene-butadiene rubber (SBR) based anionic emulsion modified with functional monomers, designed for high-performance cementitious and construction applications. It is formulated to be APEO-free and low in VOC, offering excellent water, acid, and alkali resistance. It enhances flexural and tensile strength, improves waterproofing, and increases carbonation resistance of reinforced concrete while maintaining good workability with cement and asphalt systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/FjXUmghUkW8y8qtNgBo2txZwKEbJuYDpVEhchmCx.webp",
        url: "https://hutaib.org/product/his-sbr-7303",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_SBR_7303.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-sbr-7303",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-sbr-7303#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "SBR Grades",
            item: {
              "@id": "https://hutaib.org/product-category/sbr-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS SBR 7303",
            item: {
              "@id": "https://hutaib.org/product/his-sbr-7303#product",
            },
          },
        ],
      },
    ],
  },

  "/product/his-sbr-8860/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/his-sbr-8860#product",
        name: "HIS SBR 8860",
        description:
          "HIS SBR 8860 is a latex-based styrene-butadiene rubber (SBR) cement-compatible additive designed to enhance waterproofing, flexibility, and overall durability of cementitious systems. It provides improved performance in construction applications where a balance between cost efficiency and mechanical enhancement is required, making it suitable for a wide range of waterproofing and modification uses.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/mm2PnIvw533KZI1KI7KXiXp3YSsVIIFYU4Cvvaze.webp",
        url: "https://hutaib.org/product/his-sbr-8860",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/HIS_SBR_8860.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/his-sbr-8860",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/his-sbr-8860#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "SBR Grades",
            item: {
              "@id": "https://hutaib.org/product-category/sbr-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "HIS SBR 8860",
            item: {
              "@id": "https://hutaib.org/product/his-sbr-8860#product",
            },
          },
        ],
      },
    ],
  },

  "product/lipaton-sb-5843/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/lipaton-sb-5843#product",
        name: "LIPATON™ SB 5843",
        description:
          "LIPATON™ SB 5843 is a high-stability styrene-butadiene copolymer aqueous dispersion designed for cementitious systems. It is formulated with an APEO-free anionic/nonionic emulsifier system and is free from solvents, plasticizers, ammonia, and film-forming aids. It improves adhesion, flexibility, and durability of cement mortars while maintaining low air content through a built-in defoaming system.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/KCJnQ2UXXbSgXVkiQNhmVADIg8rZQHS8L5C902HH.webp",
        url: "https://hutaib.org/product/lipaton-sb-5843",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/LIPATON_SB_5843.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/lipaton-sb-5843",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/lipaton-sb-5843#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "SBR Grades",
            item: {
              "@id": "https://hutaib.org/product-category/sbr-grades",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "LIPATON™ SB 5843",
            item: {
              "@id": "https://hutaib.org/product/lipaton-sb-5843#product",
            },
          },
        ],
      },
    ],
  },

  "/product/revacryl-ae-2091-ja/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/revacryl-ae-2091-ja#product",
        name: "REVACRYL™ AE 2091 JA",
        description:
          "REVACRYL™ AE 2091 JA is a high solid content water-based styrene-acrylic copolymer dispersion designed for advanced construction applications. It is free from solvents, plasticizers, ammonia, and film-forming agents, and forms a clear, tacky film above its minimum film forming temperature. It is highly compatible with cementitious systems and is used as an elastifying component in flexible waterproofing membranes and sealants.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/Vgw3UzdGSWmTjsGp9wHV9FAU6qTr3ny3mrECOgo2.webp",
        url: "https://hutaib.org/product/revacryl-ae-2091-ja",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/REVACRYL_AE_2091_JA_Technical_Dat_a_Sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/revacryl-ae-2091-ja",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/revacryl-ae-2091-ja#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Styrene Acrylic",
            item: {
              "@id": "https://hutaib.org/product-category/styrene-acrylic",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "REVACRYL™ AE 2091 JA",
            item: {
              "@id": "https://hutaib.org/product/revacryl-ae-2091-ja#product",
            },
          },
        ],
      },
    ],
  },

  "/product/revacryl-ae-3020/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/revacryl-ae-3020#product",
        name: "REVACRYL™ AE 3020",
        description:
          "REVACRYL™ AE 3020 is a water-based styrene-acrylic copolymer dispersion designed for construction applications such as waterproofing systems and ceramic tile bonding. It is formulated without solvents, plasticizers, or film-forming agents and provides strong adhesion, durability, and compatibility with cementitious substrates.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/yKs2xK6b7sGvEnuucAqP5Lepaay6IpZRNSJhUKFy.webp",
        url: "https://hutaib.org/product/revacryl-ae-3020",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/REVACRYL_AE_3020_Construction.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/revacryl-ae-3020",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/revacryl-ae-3020#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Styrene Acrylic",
            item: {
              "@id": "https://hutaib.org/product-category/styrene-acrylic",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "REVACRYL™ AE 3020",
            item: {
              "@id": "https://hutaib.org/product/revacryl-ae-3020#product",
            },
          },
        ],
      },
    ],
  },

  "/product/water-guard-3020/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/water-guard-3020#product",
        name: "Water Guard 3020",
        description:
          "Water Guard 3020N is a one-component acrylic copolymer-based flexible waterproofing system designed for protecting cementitious and metal surfaces. It provides durable waterproofing performance in demanding environments such as roofs, balconies, bathrooms, basements, swimming pools, wet areas, and lift pits, where conventional waterproofing systems may not be suitable.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/xep7FYqkIrtpbr4vcoqrGkhRC70F6rhCQHsR4FYB.webp",
        url: "https://hutaib.org/product/water-guard-3020",
        category: "Construction Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Water_Guard_3020N.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/water-guard-3020",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/water-guard-3020#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Styrene Acrylic",
            item: {
              "@id": "https://hutaib.org/product-category/styrene-acrylic",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Water Guard 3020",
            item: {
              "@id": "https://hutaib.org/product/water-guard-3020#product",
            },
          },
        ],
      },
    ],
  },

  "/product/bluesil-extrasoft-c845-a2/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bluesil-extrasoft-c845-a2#product",
        name: "BLUESIL™ EXTRASOFT C845 A2",
        description:
          "BLUESIL™ EXTRASOFT C845 A2 is a diamine-functional silicone oil designed for use in textile finishing emulsions. It is formulated to enhance fabric softness, smoothness, and overall hand feel, making it suitable for advanced textile softening and finishing applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/4U3tq0xWXa6S4Vk170CWzhqx5VoM8j9XrDFofzIy.webp",
        url: "https://hutaib.org/product/bluesil-extrasoft-c845-a2",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Bluesil_Extrasoft_C845_1.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bluesil-extrasoft-c845-a2",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/bluesil-extrasoft-c845-a2#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BLUESIL™ EXTRASOFT C845 A2",
            item: {
              "@id":
                "https://hutaib.org/product/bluesil-extrasoft-c845-a2#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bluesil-supersoft-c910-a2/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bluesil-supersoft-c910-a2#product",
        name: "BLUESIL™ SUPERSOFT C910 A2",
        description:
          "BLUESIL™ SUPERSOFT C910 A2 is a high amine content, medium to low viscosity diamino-functionalized polydimethylsiloxane designed for textile softening applications. It is formulated for use in emulsions to improve fabric softness, smoothness, and handle in both woven and knitted textile processing systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/BFf5fgSuNhArFKuiYLYErrgAiL3yZK9iPTl28xst.webp",
        url: "https://hutaib.org/product/bluesil-supersoft-c910-a2",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Bluesil_Supersoft_C910.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bluesil-supersoft-c910-a2",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/bluesil-supersoft-c910-a2#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BLUESIL™ SUPERSOFT C910 A2",
            item: {
              "@id":
                "https://hutaib.org/product/bluesil-supersoft-c910-a2#product",
            },
          },
        ],
      },
    ],
  },
  "/product/ge-01530/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ge-01530#product",
        name: "GE 01530",
        description:
          "GE 01530 is a low viscosity, non-reactive amino-functional silicone textile softener designed to impart exceptional softness and a smooth, limp hand feel to fabrics. It is optimized for use in textile finishing applications where enhanced softness and handle improvement are required.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/oucTiuBCHfOqpEHht4nKHz9WX0fp72PClGGmU41C.webp",
        url: "https://hutaib.org/product/ge-01530",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/ge_01530_silcone_fluid.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ge-01530",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ge-01530#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "GE 01530",
            item: {
              "@id": "https://hutaib.org/product/ge-01530#product",
            },
          },
        ],
      },
    ],
  },
  "/product/fabric-softener-magnasoft-plus/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/fabric-softener-magnasoft-plus#product",
        name: "Magnasoft Plus",
        description:
          "Magnasoft Plus is a specially engineered low amino-containing silicone fluid designed for textile softening applications. It delivers a soft, silky, and full fabric handle comparable to conventional amino-modified silicone softeners while significantly reducing yellowing, making it suitable for high-quality textile finishing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/nLTCv1zTjHDRZOn8rl7J0Pxe3kaMOuN3lsTiXp5Q.webp",
        url: "https://hutaib.org/product/fabric-softener-magnasoft-plus",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magnasoft-plus-marketing-bulletin.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/fabric-softener-magnasoft-plus",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/fabric-softener-magnasoft-plus#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft Plus",
            item: {
              "@id":
                "https://hutaib.org/product/fabric-softener-magnasoft-plus#product",
            },
          },
        ],
      },
    ],
  },
  "/product/water-repellent-coating-sf-3830/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/water-repellent-coating-sf-3830#product",
        name: "SF-3830",
        description:
          "SF-3830 is a medium viscosity reactive amino-functional silicone fluid designed for textile finishing applications. It is optimized to impart durable softness and a slightly grabby hand feel to a wide range of woven and nonwoven fabrics, enhancing overall fabric handle and performance in textile processing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/3zLk3r8qXiyBdrUoJJkNCfb2LaYJHuGsoonA53xK.webp",
        url: "https://hutaib.org/product/water-repellent-coating-sf-3830",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/sf-3830.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/water-repellent-coating-sf-3830",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/water-repellent-coating-sf-3830#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "SF-3830",
            item: {
              "@id":
                "https://hutaib.org/product/water-repellent-coating-sf-3830#product",
            },
          },
        ],
      },
    ],
  },
  "/product/high-solids-paint-sf-4901/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/high-solids-paint-sf-4901#product",
        name: "SF-4901",
        description:
          "SF-4901 is a low amino-containing silicone fluid designed for textile softening applications. It is engineered to deliver a soft, silky, and full fabric handle similar to conventional amino-modified silicone softeners while significantly reducing yellowing tendencies. It is suitable for improving the hand feel of a wide range of textile substrates.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/mewIMiSNSELkoJ8F6dvCJM8HnJaT90mhKVpACe47.webp",
        url: "https://hutaib.org/product/high-solids-paint-sf-4901",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/sf-4901-amino-silicone-fluid.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/high-solids-paint-sf-4901",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/high-solids-paint-sf-4901#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "SF-4901",
            item: {
              "@id":
                "https://hutaib.org/product/high-solids-paint-sf-4901#product",
            },
          },
        ],
      },
    ],
  },
  "/product/performance-additive-tsf-4703/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/performance-additive-tsf-4703#product",
        name: "TSF-4703",
        description:
          "TSF-4703 is an amino-functional silicone fluid designed for textile softener applications. It can be easily emulsified into stable microemulsions that provide durable softness, smoothness, and improved handle to cotton, cotton blends, woven fabrics, and knitted textiles.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/qhD3r2mdOZSRgWJ7HD2McYZ3KwBylklew9GHjwHL.webp",
        url: "https://hutaib.org/product/performance-additive-tsf-4703",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/TSF4703_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/performance-additive-tsf-4703",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/performance-additive-tsf-4703#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "TSF-4703",
            item: {
              "@id":
                "https://hutaib.org/product/performance-additive-tsf-4703#product",
            },
          },
        ],
      },
    ],
  },
  "/product/specialty-coating-agent-tsf-4708/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/specialty-coating-agent-tsf-4708#product",
        name: "TSF-4708",
        description:
          "TSF-4708 is an amino-functional silicone fluid designed for textile softener applications. It is easily emulsified into stable microemulsions that provide durable softness, smoothness, and improved fabric handle for cotton, cotton blends, woven fabrics, and knitted textiles.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/DSZ1cHgTywu6M4Ih0GYfI8e0ECbiia1U8u4XYVqa.webp",
        url: "https://hutaib.org/product/specialty-coating-agent-tsf-4708",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/TSF4708_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/specialty-coating-agent-tsf-4708",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/specialty-coating-agent-tsf-4708#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "TSF-4708",
            item: {
              "@id":
                "https://hutaib.org/product/specialty-coating-agent-tsf-4708#product",
            },
          },
        ],
      },
    ],
  },
  "/product/xiameter-ofx-8040-fluid/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/xiameter-ofx-8040-fluid#product",
        name: "XIAMETER™ OFX-8040 Fluid",
        description:
          "XIAMETER™ OFX-8040 Fluid is a specialty silicone-based amino functional fluid designed for textile applications. It is suitable for formulation into microemulsions and can be applied to woven and knitted fabrics to impart a soft handle, enhancing fabric smoothness and tactile performance.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/hXn8jE5j5Tjyh0TmWaK60A9XJtZChGCRlalHDyv3.webp",
        url: "https://hutaib.org/product/xiameter-ofx-8040-fluid",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/XIAMETER_OFX_8040_Fluid.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/xiameter-ofx-8040-fluid",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/xiameter-ofx-8040-fluid#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "XIAMETER™ OFX-8040 Fluid",
            item: {
              "@id":
                "https://hutaib.org/product/xiameter-ofx-8040-fluid#product",
            },
          },
        ],
      },
    ],
  },
  "/product/xiameter-ofx-8468-fluid/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/xiameter-ofx-8468-fluid#product",
        name: "XIAMETER™ OFX-8468 Fluid",
        description:
          "XIAMETER™ OFX-8468 Fluid is a silicone-based amino functional fluid designed for textile finishing applications. It is formulated for use in microemulsions that can be applied via padding or exhaustion processes, providing soft handle and improved fabric performance in woven and knitted textiles.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/NeUW7HY7gated0acW1qO0FoL1ylUxGUGxRVlp9wB.webp",
        url: "https://hutaib.org/product/xiameter-ofx-8468-fluid",
        category: "Textile Chemical",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/8468.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/xiameter-ofx-8468-fluid",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/xiameter-ofx-8468-fluid#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Amino Functional Fluids",
            item: {
              "@id":
                "https://hutaib.org/product-category/momentive-amino-functional-fluid",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "XIAMETER™ OFX-8468 Fluid",
            item: {
              "@id":
                "https://hutaib.org/product/xiameter-ofx-8468-fluid#product",
            },
          },
        ],
      },
    ],
  },

  "/product/ressisoft-s116/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ressisoft-s116#product",
        name: "RessiSoft S116 (Hydrophilic Block Silicone Fluids)",
        description:
          "RessiSoft S116 is a multifunctional modified block silicone fluid designed for textile applications on both natural and synthetic fabrics. It provides a smooth, soft, and slippery hand feel with low yellowing and excellent stability. It also offers good hydrophilicity on natural fabrics and strong resistance against phenolic yellowing, with very low cyclic silicone content (D4, D5, D6 below 1000 ppm each).",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/lbTgfAtxsp2HQJDo43aftguG8c9WawW7rontkIKR.webp",
        url: "https://hutaib.org/product/ressisoft-s116",
        category: "Silicone Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RessiSoft_S116.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ressisoft-s116",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ressisoft-s116#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Block Silicone Fluids",
            item: {
              "@id": "https://hutaib.org/product-category/silicone-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RessiSoft S116 (Hydrophilic Block Silicone Fluids)",
            item: {
              "@id": "https://hutaib.org/product/ressisoft-s116#product",
            },
          },
        ],
      },
    ],
  },
  "/product/ressisoft-pearl/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ressisoft-pearl#product",
        name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
        description:
          "RessiSoft Pearl is a high-concentration quaternary block-structured silicone softener designed for textile finishing applications across cotton, cotton blends, rayon, viscose, synthetic fibers, silk, and wool. It provides excellent softness, strong hydrophilicity, and outstanding stability under acidic, alkaline, and high-temperature conditions without emulsion breaking. It helps avoid issues such as roller sticking, offers excellent bath compatibility, prevents yellowing, and contains ultra-low D4, D5, and D6 levels compliant with Bluesign standards.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/9SpHG1R89pq6OL0gW8OYmyZTd7A6utRaqc3spfdH.webp",
        url: "https://hutaib.org/product/ressisoft-pearl",
        category: "Silicone Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RessiSoft_Pearl.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ressisoft-pearl",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ressisoft-pearl#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Block Silicone Fluids",
            item: {
              "@id": "https://hutaib.org/product-category/silicone-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
            item: {
              "@id": "https://hutaib.org/product/ressisoft-pearl#product",
            },
          },
        ],
      },
    ],
  },
  "/product/textile-softener-ressisoft-nt/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/textile-softener-ressisoft-nt#product",
        name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
        description:
          "RESSISOFT NT is a high-concentration quaternary block-structured hydrophilic silicone oil in primary form designed for textile finishing applications. It is suitable for cotton, cotton blends, rayon, viscose, synthetic fibers, silk, and wool, especially where high hydrophilicity is required. It delivers excellent stability under acidic, alkaline, and high-temperature conditions without emulsion breaking, prevents issues such as roller sticking, and provides a soft, smooth hand feel without yellowing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/lNUDxkqjZZjfdjs6FhW5zdbxrLTjeDN79aqrnP9n.webp",
        url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
        category: "Silicone Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RESSISOFT_NT.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/textile-softener-ressisoft-nt#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Block Silicone Fluids",
            item: {
              "@id": "https://hutaib.org/product-category/silicone-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
            item: {
              "@id":
                "https://hutaib.org/product/textile-softener-ressisoft-nt#product",
            },
          },
        ],
      },
    ],
  },
  "/product/ressisoft-eco/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ressisoft-eco#product",
        name: "RessiSoft ECO (Hydrophobic Block Silicone Fluids)",
        description:
          "RessiSoft ECO is a self-dispersible polyether-amino-functional silicone fluid designed for textile finishing applications. It can be used on natural and synthetic fabrics such as cotton, polyester, towels, and blended materials. It provides a distinctive soft hand feel, broad fabric compatibility, good stability, and minimal impact on shade change, making it suitable for versatile textile processing applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/cmjAEyREsWIcERqAX2Qc0kCuQMPbFT8WXyLnwQwM.webp",
        url: "https://hutaib.org/product/ressisoft-eco",
        category: "Silicone Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RessiSoft_ECO.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ressisoft-eco",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ressisoft-eco#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Block Silicone Fluids",
            item: {
              "@id": "https://hutaib.org/product-category/silicone-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RessiSoft ECO (Hydrophobic Block Silicone Fluids)",
            item: {
              "@id": "https://hutaib.org/product/ressisoft-eco#product",
            },
          },
        ],
      },
    ],
  },
  "/product/ressisoft-bostex/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ressisoft-bostex#product",
        name: "RessiSoft BosTex (Hydrophobic Block Silicone Fluids)",
        description:
          "RessiSoft BosTex is a high-concentration quaternary block-structured silicone softener designed for textile finishing applications. It is suitable for cotton, cotton blends, rayon, viscose, and synthetic fibers, providing smoothness, softness, and excellent stability. It performs well under acidic, alkaline, and high-temperature conditions, helps prevent issues such as roller sticking, and delivers a soft hand feel with very low yellowing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/EwdxGRPW9E6q2za9R91prNGBt1Wv0Opl2qWyXVbw.webp",
        url: "https://hutaib.org/product/ressisoft-bostex",
        category: "Silicone Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RessiSoft_BosTex.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ressisoft-bostex",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ressisoft-bostex#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Block Silicone Fluids",
            item: {
              "@id": "https://hutaib.org/product-category/silicone-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RessiSoft BosTex (Hydrophobic Block Silicone Fluids)",
            item: {
              "@id": "https://hutaib.org/product/ressisoft-bostex#product",
            },
          },
        ],
      },
    ],
  },

  "/product/silicone-based-coating-magnasoft-silq/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/silicone-based-coating-magnasoft-silq#product",
        name: "MagnaSoft SilQ",
        description:
          "MagnaSoft SilQ is a textile softening and finishing enhancer designed to provide a luxuriously soft, smooth, and flexible hand feel. It is suitable for cellulosic, regenerated cellulosic, and blended fabrics, improving overall fabric softness and drape in textile finishing applications.",
        image: "https://hutaib.org/static/media/product.273b4c95.jpg",
        url: "https://hutaib.org/product/silicone-based-coating-magnasoft-silq",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magnasoft_silq_mp-indd.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/silicone-based-coating-magnasoft-silq",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/silicone-based-coating-magnasoft-silq#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "MagnaSoft SilQ",
            item: {
              "@id":
                "https://hutaib.org/product/silicone-based-coating-magnasoft-silq#product",
            },
          },
        ],
      },
    ],
  },
  "/product/textile-softening-agent-magnasoft-scitex/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex#product",
        name: "Magnasoft SciTex",
        description:
          "Magnasoft SciTex is a concentrated silicone co-polymer textile softener designed to provide cost-effective fabric finishing performance. It delivers a luxurious, soft hand feel on cotton and cotton blend fabrics while maintaining fabric softness and overall comfort without compromising handle quality.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/UAB5rNaCwMrheWoFD7dEsrvsrqPrN51h3sxXzCmt.webp",
        url: "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magnasoft-scitex-marketing-bulletin.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft SciTex",
            item: {
              "@id":
                "https://hutaib.org/product/textile-softening-agent-magnasoft-scitex#product",
            },
          },
        ],
      },
    ],
  },
  "/product/skin-care-emulsion-magnasoft-derma-nt/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt#product",
        name: "Magnasoft Derma NT",
        description:
          "Magnasoft Derma NT is a patented quat-functional silicone copolymer textile enhancer with a repeating block structure that integrates multiple chemical functionalities in a single linear molecule. It is designed for textile finishing applications, offering excellent emulsion stability, suitability for spray and exhaust application methods, and consistent delivery of softening and performance benefits.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/6SgL01b7rgAwx0abjWQL6Sg1i31pHLyIXYyxMM28.webp",
        url: "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magnasoft-derma-nt_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft Derma NT",
            item: {
              "@id":
                "https://hutaib.org/product/skin-care-emulsion-magnasoft-derma-nt#product",
            },
          },
        ],
      },
    ],
  },
  "/product/ressisoft-pearl/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/ressisoft-pearl#product",
        name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
        description:
          "RessiSoft Pearl is a high-concentration quaternary block-structured silicone softener designed for textile finishing applications. It is suitable for cotton, cotton blends, rayon, viscose, synthetic fibers, silk, and wool, especially where high hydrophilicity is required. It delivers excellent stability under acidic, alkaline, and high-temperature conditions without emulsion breaking, avoids issues such as roller and cylinder sticking, provides excellent softness without yellowing, and contains ultra-low D4, D5, and D6 levels compliant with Bluesign standards.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/9SpHG1R89pq6OL0gW8OYmyZTd7A6utRaqc3spfdH.webp",
        url: "https://hutaib.org/product/ressisoft-pearl",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RessiSoft_Pearl.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/ressisoft-pearl",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/ressisoft-pearl#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RessiSoft Pearl (Hydrophilic Block Silicone Fluids)",
            item: {
              "@id": "https://hutaib.org/product/ressisoft-pearl#product",
            },
          },
        ],
      },
    ],
  },
  "/product/quartz-based-softener-ressisoft-quartz/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz#product",
        name: "RESSISOFT QUARTZ",
        description:
          "RESSISOFT QUARTZ is a quaternary-modified hydrophilic silicone oil designed for textile finishing applications. It provides instant hydrophilicity along with superior softness and smoothness, making it suitable for all types of cotton fabrics and enhancing overall fabric handle in finishing processes.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/ce3lqkHmPtrHfwLcZ4aNdamb4I3nkzaXpSfy0QhV.webp",
        url: "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RESSISOFT_QUARTZ.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RESSISOFT QUARTZ",
            item: {
              "@id":
                "https://hutaib.org/product/quartz-based-softener-ressisoft-quartz#product",
            },
          },
        ],
      },
    ],
  },
  "/product/textile-softener-ressisoft-nt/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/textile-softener-ressisoft-nt#product",
        name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
        description:
          "RESSISOFT NT is a high-concentration quaternary block-structured hydrophilic silicone oil in primary form designed for textile finishing applications. It is suitable for cotton, cotton blends, rayon, viscose, synthetic fibers, silk, and wool, particularly where high hydrophilicity is required. It offers excellent stability under acidic, alkaline, and high-temperature conditions without emulsion breaking, prevents processing issues such as roller sticking, delivers a soft hand feel, and does not cause yellowing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/lNUDxkqjZZjfdjs6FhW5zdbxrLTjeDN79aqrnP9n.webp",
        url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
        category: "Hydrophilic Oil",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/RESSISOFT_NT.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/textile-softener-ressisoft-nt",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/textile-softener-ressisoft-nt#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Hydrophilic",
            item: {
              "@id": "https://hutaib.org/product-category/hydrophilic-oil",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "RESSISOFT NT (Hydrophilic Block Silicone Fluids)",
            item: {
              "@id":
                "https://hutaib.org/product/textile-softener-ressisoft-nt#product",
            },
          },
        ],
      },
    ],
  },

  "/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst#product",
        name: "PDMS Fluid 350 CST",
        description:
          "PDMS Fluid 350 CST is a linear polydimethylsiloxane (PDMS) silicone oil with medium viscosity. It belongs to a range of kinematic viscosity grades and is used in various industrial and formulation applications where stable silicone-based fluids are required for performance consistency.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/7s49QQB1Igol9T51ONdIDzky913A569sBdKkbRZt.webp",
        url: "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst",
        category: "Polydimethylsiloxane",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/element14-pdms-350.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "PDMS Emulsion",
            item: {
              "@id": "https://hutaib.org/product-category/polydimethylsiloxane",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "PDMS Fluid 350 CST",
            item: {
              "@id":
                "https://hutaib.org/product/medium-viscosity-silicone-oil-pdms-fluid-350-cst#product",
            },
          },
        ],
      },
    ],
  },

  "/product/boscare-tep-88/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/boscare-tep-88#product",
        name: "BosCare TEP-88",
        description:
          "BosCare TEP-88 is an aliphatic amide derivative textile softener developed for fabric finishing applications. It is suitable for a wide range of fabrics and is particularly effective for denim garment washing, where it helps provide a soft hand feel while enhancing anti-ozone performance and reducing color fading during textile processing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/1kDtKfXKUtJHfqP4o0BIBVBoFTPDVkz5z8vXEwSa.webp",
        url: "https://hutaib.org/product/boscare-tep-88",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosCare_TEP-88.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/boscare-tep-88",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/boscare-tep-88#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosCare TEP-88",
            item: {
              "@id": "https://hutaib.org/product/boscare-tep-88#product",
            },
          },
        ],
      },
    ],
  },
  "/product/eco-friendly-softener-magnasoft-68/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/eco-friendly-softener-magnasoft-68#product",
        name: "Magnasoft 68",
        description:
          "Magnasoft 68 is a self-cross-linkable silicone emulsion textile softener developed to deliver exceptional surface smoothness and an elastomeric soft hand feel on cotton and synthetic fabrics. Its reactive silicone technology forms a durable two-dimensional elastomeric film during drying or curing, providing enhanced softness, flexibility, and long-lasting fabric performance for woven and knitted textile applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/rhIUlFd7EVN9eSl1mr8TZog2opVwV1SvKtrseI8s.webp",
        url: "https://hutaib.org/product/eco-friendly-softener-magnasoft-68",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magnasoft-68.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/eco-friendly-softener-magnasoft-68",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/eco-friendly-softener-magnasoft-68#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 68",
            item: {
              "@id":
                "https://hutaib.org/product/eco-friendly-softener-magnasoft-68#product",
            },
          },
        ],
      },
    ],
  },
  "/product/multifunctional-softener-magnasoft-88/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/multifunctional-softener-magnasoft-88#product",
        name: "Magnasoft 88",
        description:
          "Magnasoft 88 is a highly concentrated modified silicone microemulsion textile softener formulated to deliver exceptional softness and lubrication across a wide variety of fabrics. It provides an extra silky, slippery hand feel while enhancing fabric comfort and finishing performance, making it suitable for premium textile processing applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/04c6GmaxF9V2BsH3TfJ5IW59kUJPFb1w9o8X1VTU.webp",
        url: "https://hutaib.org/product/multifunctional-softener-magnasoft-88",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/magna-soft-88.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/multifunctional-softener-magnasoft-88",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/multifunctional-softener-magnasoft-88#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 88",
            item: {
              "@id":
                "https://hutaib.org/product/multifunctional-softener-magnasoft-88#product",
            },
          },
        ],
      },
    ],
  },
  "/product/performance-enhancer-magnasoft-110/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/performance-enhancer-magnasoft-110#product",
        name: "Magnasoft 110",
        description:
          "Magnasoft 110 is an advanced silicone-based textile softener formulated with a linear polydimethylsiloxane amine polyalkyleneoxide copolymer. It delivers a soft, silky, and full hand feel across a wide range of fabrics while minimizing yellowing. Designed for modern textile finishing, it is compatible with fluorocarbon soil-release systems and enhances fabric softness without compromising soil-release performance.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/crKK4hX59SQW4voKX0ctAFgNMrJmlng5lTmWFnAG.webp",
        url: "https://hutaib.org/product/performance-enhancer-magnasoft-110",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Magnasoft_110_Data_sheet.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/performance-enhancer-magnasoft-110",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/performance-enhancer-magnasoft-110#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 110",
            item: {
              "@id":
                "https://hutaib.org/product/performance-enhancer-magnasoft-110#product",
            },
          },
        ],
      },
    ],
  },
  "/product/versatile-textile-auxiliary-magnasoft-238/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238#product",
        name: "Magnasoft 238",
        description:
          "Magnasoft 238 is an advanced silicone copolymer textile enhancer developed using (AB)n technology for high-performance fabric finishing. It provides exceptional softness, slickness, and fabric comfort while minimizing yellowing, thermal migration, and shear stability loss. Its water-dispersible formulation delivers efficient performance at low dosage levels and complies with modern EU REACH SVHC requirements through ultra-low residual cyclic siloxane content.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/7PpD81epW1I3jGXGTvk5nC2fUEcyjgi7jaDRsEMT.webp",
        url: "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Magnasoft_238-LT_textile_enhancer_TDS_ENG_LTR_LR_(1).pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 238",
            item: {
              "@id":
                "https://hutaib.org/product/versatile-textile-auxiliary-magnasoft-238#product",
            },
          },
        ],
      },
    ],
  },
  "/product/textile-conditioning-agent-magnasoft-588-tx/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx#product",
        name: "Magnasoft 588 TX",
        description:
          "Magnasoft 588 TX is a specialty silicone emulsion concentrate developed for textile finishing applications requiring superior softness, rapid water absorbency, and effective moisture management. It provides excellent shear stability across a wide range of pH and temperature conditions while helping maintain fabric whiteness and minimizing discoloration, making it suitable for premium and cost-effective textile finishing processes.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/L9M27WWFLZu9Yu2pLdAbwqlO4XbMGqgtxBN7TJ99.webp",
        url: "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Magnasoft_588TX_MB_approved.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 588 TX",
            item: {
              "@id":
                "https://hutaib.org/product/textile-conditioning-agent-magnasoft-588-tx#product",
            },
          },
        ],
      },
    ],
  },
  "/product/high-performance-softener-magnasoft-915/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/high-performance-softener-magnasoft-915#product",
        name: "Magnasoft 915",
        description:
          "Magnasoft 915 is a high-performance textile enhancer developed for cotton woven and knitted fabrics. It is engineered as an advanced alternative to conventional amino silicone microemulsions, delivering exceptional softness, excellent shear stability, and reliable performance under demanding textile finishing conditions, including elevated pH and temperature.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/2joOyc1cZgZQU9NNyfgmmLZdrdkiT7JliVRkQRh6.webp",
        url: "https://hutaib.org/product/high-performance-softener-magnasoft-915",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Magnasoft_915_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/high-performance-softener-magnasoft-915",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/high-performance-softener-magnasoft-915#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft 915",
            item: {
              "@id":
                "https://hutaib.org/product/high-performance-softener-magnasoft-915#product",
            },
          },
        ],
      },
    ],
  },
  "/product/oil-resistant-softener-magnasoft-ops/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id":
          "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops#product",
        name: "Magnasoft OPS",
        description:
          "Magnasoft OPS is a specialty silicone emulsion textile softener formulated to enhance the performance of a wide range of fabrics. It provides an excellent balance of deep softness, a dry and cool hand feel, improved fabric drape, hydrophilicity for enhanced absorbency, and outstanding bath stability, making it suitable for demanding textile finishing applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/MdCN3YJWJBHhZsB1Ak9CKxoMigcnj09jR07At2ZO.webp",
        url: "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops",
        category: "Softener",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Magnasoft_OPS_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id":
          "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Softener",
            item: {
              "@id":
                "https://hutaib.org/product-category/softeners-for-textile",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Magnasoft OPS",
            item: {
              "@id":
                "https://hutaib.org/product/oil-resistant-softener-magnasoft-ops#product",
            },
          },
        ],
      },
    ],
  },

  "/product/bossurf-50/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-50#product",
        name: "BosSurf XL-50",
        description:
          "BosSurf XL-50 is a premium nonionic surfactant based on isodecyl alcohol ethoxylates, formulated to deliver outstanding wetting, emulsifying, and dispersing performance in textile, industrial, and cleaning applications. It effectively reduces surface tension to improve soil removal, formulation stability, and processing efficiency while offering a biodegradable solution for environmentally responsible manufacturing.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/Zypbp7gxDnNf0ReUyjBKaECWj9269wtdBXhyWfEE.webp",
        url: "https://hutaib.org/product/bossurf-50",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_50_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-50",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-50#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf XL-50",
            item: {
              "@id": "https://hutaib.org/product/bossurf-50#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-70/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-70#product",
        name: "BosSurf XL-70",
        description:
          "BosSurf XL-70 is a high-performance nonionic surfactant based on isodecyl alcohol ethoxylates, engineered for textile, leather, paper, detergent, agricultural, and industrial formulations. It delivers outstanding wetting, dispersing, and emulsifying performance while providing an effective alternative to alkylphenol ethoxylates in environmentally conscious applications. Its excellent formulation compatibility and processing efficiency make it suitable for a wide range of industrial chemical systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/lXh68TEANXQ73k62M4rPtiUFFljb2thjLtYpQQvU.webp",
        url: "https://hutaib.org/product/bossurf-70",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_70_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-70",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-70#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf XL-70",
            item: {
              "@id": "https://hutaib.org/product/bossurf-70#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-to3/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-to3#product",
        name: "Bossurf-TO3",
        description:
          "Bossurf-TO3 is a nonionic surface active agent designed for use in textile processing, detergent formulations, and chemical manufacturing applications. It provides effective wetting, emulsifying, and dispersing performance, making it suitable as a versatile raw material for a wide range of industrial chemical processes.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/Su2bmGgyT79JDYix3SZfETuAQkuphFGvgvAY7q9.webp",
        url: "https://hutaib.org/product/bossurf-to3",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Bossurf_TO3_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-to3",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-to3#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Bossurf-TO3",
            item: {
              "@id": "https://hutaib.org/product/bossurf-to3#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-to5/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-to5#product",
        name: "BosSurf-TO5",
        description:
          "BosSurf-TO5 is a nonionic surfactant derived from isotridecyl alcohol and ethylene oxide. It is designed for use in textile processing, detergent formulations, and industrial chemical applications, where it delivers effective wetting, emulsifying, and dispersing performance. Its formulation supports improved surface activity and process efficiency across a wide range of manufacturing systems.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/prpoZIFPld3kl1WwZNzTx0GzXHDhJ3PwqohI7zIN.webp",
        url: "https://hutaib.org/product/bossurf-to5",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_TO5.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-to5",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-to5#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf-TO5",
            item: {
              "@id": "https://hutaib.org/product/bossurf-to5#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-to6/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-to6#product",
        name: "BosSurf-TO6",
        description:
          "BosSurf-TO6 is a nonionic surfactant with a unique ethoxylated alcohol structure, combining hydrophilic polyethylene glycol and lipophilic alkyl chains. It provides effective emulsification, dispersion, and wetting performance and is widely used in cleaning, agriculture, textiles, and personal care applications.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/BE91Scrdg5Ef2WAr0VXJLoFUaXpG0Yo2WOBIBzJ7.webp",
        url: "https://hutaib.org/product/bossurf-to6",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_TO6_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-to6",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-to6#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "https://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Construction Chemical",
            item: {
              "@id":
                "https://hutaib.org/product-category/construction-chemicals",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf-TO6",
            item: {
              "@id": "https://hutaib.org/product/bossurf-to6#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-to7/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-to7#product",
        name: "Bossurf-TO7",
        description:
          "This product is made from isotridecyl alcohol and ethylene oxide.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/4dFq3I0IE789MW9QOaILSkuHJPC3rYBPa6qKhc10.webp",
        url: "https://hutaib.org/product/bossurf-to7",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Bossurf_TO7.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-to7",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-to7#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "https://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Bossurf-TO7",
            item: {
              "@id": "https://hutaib.org/product/bossurf-to7#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-to8/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-to8#product",
        name: "BosSurf-TO8",
        description:
          "BosSurf-TO8 is a nonionic surfactant with a unique ethoxylated alcohol structure, combining hydrophilic polyethylene glycol and lipophilic alkyl chains. It provides effective emulsification, dispersion, and wetting performance and is widely used across cleaning, agriculture, textiles, and personal care industries.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/SDEYu5LviNKXro08uzJOALBU5cVAn5F3bUAkwVr8.webp",
        url: "https://hutaib.org/product/bossurf-to8",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/Bossurf_TO8_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-to8",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-to8#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "https://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf-TO8",
            item: {
              "@id": "https://hutaib.org/product/bossurf-to8#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-xp30/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-xp30#product",
        name: "BosSurf-XP30",
        description:
          "BosSurf-XP30 is a premium nonionic surfactant derived from isodecyl alcohol and ethylene oxide, engineered for textile, detergent, and industrial formulations. It offers excellent wetting, emulsifying, and dispersing performance while improving formulation stability and processing efficiency. BosSurf-XP30 is suitable for a wide range of specialty chemical applications where reliable surface-active performance is required.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/LVI6Ri1A8yYmXn3UDIENUYI7vV48pKM9L2KT7ksk.webp",
        url: "https://hutaib.org/product/bossurf-xp30",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_XP30.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-xp30",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-xp30#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf-XP30",
            item: {
              "@id": "https://hutaib.org/product/bossurf-xp30#product",
            },
          },
        ],
      },
    ],
  },
  "/product/bossurf-xp50/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Product",
        "@id": "https://hutaib.org/product/bossurf-xp50#product",
        name: "BosSurf-XP50",
        description:
          "BosSurf-XP50 is a nonionic surfactant based on isodecyl alcohol and ethylene oxide, designed for use in textile processing, detergent formulations, and industrial applications. It provides strong wetting, emulsifying, and dispersing performance, helping improve formulation efficiency, surface activity, and overall processing consistency.",
        image:
          "https://hutaib.admin.simboz.website/storage/uploads/x1DMEfawwrybunwB43EBeAVSSvwW5m9KvZfgjTCZ.webp",
        url: "https://hutaib.org/product/bossurf-xp50",
        category: "Surfactants",
        brand: {
          "@type": "Brand",
          name: "Hutaib Industrial Solutions",
        },
        subjectOf: {
          "@type": "DigitalDocument",
          name: "Technical Datasheet",
          url: "https://hutaib.admin.simboz.website/storage/BosSurf_XP50_TDS.pdf",
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          url: "https://hutaib.org/product/bossurf-xp50",
        },
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://hutaib.org/product/bossurf-xp50#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: {
              "@id": "http://hutaib.org/",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Textile Chemical",
            item: {
              "@id": "https://hutaib.org/product-category/textile-chemical",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Surfactants",
            item: {
              "@id": "https://hutaib.org/product-category/surfactants",
            },
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "BosSurf-XP50",
            item: {
              "@id": "https://hutaib.org/product/bossurf-xp50#product",
            },
          },
        ],
      },
    ],
  },
};
